<template>
  <div class="animated" v-if="form_data">
    <b-form-group>
      <b-row>
        <b-col cols="3" class="pt-1">
          Attribute Name
        </b-col>
        <b-col>
          <b-form-input
            type="text"
            autocomplete="attribute_name"
            v-model="attribute_name"
            trim
            placeholder="Enter Attribute Name"
            :state="!$v.attribute_name.$invalid"
            invalid-feedback="Required"
          ></b-form-input>
        </b-col>
        <b-col v-if="form_data_list_length > 1" cols="0.5" class="pr-3">
          <b-button variant="danger" @click="onDelete" block>
            <i class="fal fa-trash"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group
      :state="!$v.form_data.managed_list_id.$invalid"
      invalid-feedback="Required"
      ><b-row>
        <b-col cols="3" class="pt-2">Attribute Managed List</b-col>
        <b-col>
          <add-on-select
            :options="managed_list_options"
            :selectedOption="form_data.managed_list_id"
            :customPlaceholder="'Select Attribute Managed List'"
            :isMultiple="false"
            :hideTitle="true"
            @onAddOnSelect="onSelect"
          ></add-on-select>
        </b-col>
      </b-row>
    </b-form-group>
    <b-form-group
      v-if="
        form_data.managed_list_id === '648ab5ad-c318-46bd-8974-f28eac6cb9ef'
      "
    >
      <b-row>
        <b-col cols="3" class="pt-2">Attribute Parent List</b-col>
        <b-col>
          <add-on-select
            :options="parent_attributes_options"
            :selectedOption="form_data.parent_id"
            :customPlaceholder="'Attribute Parent List'"
            :isMultiple="false"
            :hideTitle="true"
            @onAddOnSelect="onParentSelect"
          ></add-on-select>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import AddOnSelect from "../../../../.archived/submissionwizard/components/misc/AddOnSelect";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "AttributesListFieldFormGroup",
  components: { AddOnSelect },
  mixins: [validationMixin, ToastNotifications],
  props: {
    form_data: {
      type: Object,
      default: () => null
    },
    managed_list_options: {
      type: Array,
      default: () => []
    },
    parent_attributes_options: {
      type: Array,
      default: () => []
    },
    form_data_list_length: {
      type: Number,
      default: () => 0
    }
  },
  computed: {
    managed_parent_list_options() {
      return (
        (this.managed_list_options &&
          this.managed_list_options.filter(
            option => option.id !== this.form_data.managed_list_id
          )) ||
        []
      );
    },
    attribute_name: {
      get() {
        return this.form_data.value;
      },
      set(value) {
        this.$emit("handleFormDataUpdate", {
          id: this.form_data.id,
          field: "value",
          update: value
        });
      }
    }
  },
  validations: {
    attribute_name: { required },
    form_data: {
      managed_list_id: { required }
    }
  },
  methods: {
    onSelect(value) {
      this.$emit("handleFormDataUpdate", {
        id: this.form_data.id,
        field: "managed_list_id",
        update: value
      });
    },
    onParentSelect(value) {
      this.$emit("handleFormDataUpdate", {
        id: this.form_data.id,
        field: "parent_id",
        update: value
      });
    },
    onDelete() {
      this.$emit("onRemoveAttribute", this.form_data.id);
    }
  }
};
</script>
